module.exports = __webpack_public_path__ + "img/icon_sm_ccpkc.0e98526e.png";